//import request from '@/utils/request'

import {request} from './ApiService.js'

//获取问卷主题
export function Get_Paper(query) {
  return request({
    url: '/paper/Get_Paper',
    method: 'post',
    data: query,
    request
  })
}
//获取问卷主题
export function Get_Paper_List(query) {
  return request({
    url: '/paper/Get_Paper_List',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Get_Paper_preItem(query) {
  return request({
    url: '/paper/Get_Paper_preItem',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Get_Paper_dailyItem(query) {
  return request({
    url: '/paper/Get_Paper_dailyItem',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Put_Paper_PreItem(query) {
  return request({
    url: '/paper/Put_Paper_PreItem',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Put_Paper_DailyItem(query) {
  return request({
    url: '/paper/Put_Paper_DailyItem',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Get_Paper_notDailyItem(query) {
  return request({
    url: '/paper/Get_Paper_notDailyItem',
    method: 'post',
    data: query,
    request
  })
}


//查询产品列表
export function Get_Paper_RecordDailys(query) {
  return request({
    url: '/paper/Get_Paper_RecordDailys',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Put_Paper_Item(query) {
  return request({
    url: '/paper/Put_Paper_Item',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Put_Paper_Confirm(query) {
  return request({
    url: '/paper/Put_Paper_Confirm',
    method: 'post',
    data: query,
    request
  })
}


//查询产品列表
export function Get_Paper_Record(query) {
  return request({
    url: '/paper/Get_Paper_Record',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Get_Paper_RecordList(query) {
  return request({
    url: '/paper/Get_Paper_RecordList',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Det_Paper(query) {
  return request({
    url: '/paper/Det_Paper',
    method: 'post',
    data: query,
    request
  })
}

//查询产品列表
export function Get_Paper_allItem(query) {
  return request({
    url: '/paper/Get_Paper_allItem',
    method: 'post',
    data: query,
    request
  })
}







// WEBPACK FOOTER //
// ./src/api/pageOne/ApiIndex.js